import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { Col, Form, Input, message, Modal, Row, Table } from "antd";
import Column from "antd/lib/table/Column";
import { passportCheckApi } from "api/passport.api";
import { passportCheckHistoryApi } from "api/passportCheckHistory.api";
import { Pagination } from "components/Pagination";
import dayjs from "utils/dayjs";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { PassportCheck, PassportCheckHistory } from "types/passportCheck";
import { QueryParam } from "types/query";
import { Shop } from "types/shop";

import "../styles/PassportPage.scss";

export const PassportCheckHistories = ({
  visible,
  onCancel,
  selectedPassport,
}: {
  visible: boolean;
  onCancel: () => void;
  selectedPassport?: Partial<Shop>;
}) => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState<QueryParam>({ page: 1, limit: 50 });
  const [data, setData] = useState<PassportCheck[]>([]);
  const [passportCheck, setPassportCheck] = useState<PassportCheckHistory[]>(
    []
  );

  useEffect(() => {
    if (selectedPassport) fetchData();
  }, [selectedPassport, query]);

  const fetchData = async () => {
    setLoading(true);
    const resAllPassport = await passportCheckApi.findAll({ ...query });
    setData(resAllPassport.data.passportChecks);
    const res = await passportCheckHistoryApi.findAll({
      customerId: selectedPassport?.customer?.id,
      page: 1,
      limit: 50,
    });
    setPassportCheck(res.data.passportCheckHistories);
    setTotal(resAllPassport.data.total);
    setLoading(false);
  };
  return (
    (<Modal
      footer={null}
      title={
        <>
          <p style={{ marginBottom: "0.3em" }}>Lịch sử Passport</p>
          <span style={{ fontSize: "15px", fontWeight: "normal" }}>
            Tên người đại diện:{" "}
            <span style={{ fontWeight: 500 }}>
              {selectedPassport?.customer?.firstName}
            </span>
          </span>
        </>
      }
      style={{ top: 15 }}
      open={visible}
      onCancel={onCancel}
    >
      <Table
        dataSource={data}
        pagination={false}
        loading={loading}
        // scroll={{ y: 440 }}
        className="passportTb"
      >
        <Column
          title=""
          key="finish"
          width={30}
          render={(text, record: PassportCheck) => {
            const rs = passportCheck.find(
              (item) => item.passportCheck.id === record.id
            );
            console.log(passportCheck);

            return rs ? (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            ) : (
              <CloseCircleTwoTone twoToneColor="#ff4d4f" />
            );
          }}
        />
        <Column
          title="Hạng mục hoàn thành"
          key="passportCheck"
          width={250}
          render={(text, record: PassportCheck) => <span>{record.name}</span>}
        />
        <Column
          title="Thời gian hoàn thành"
          dataIndex="createdAt"
          key="age"
          render={(text, record: PassportCheck) => {
            const rs = passportCheck.find(
              (item) => item.passportCheck.id === record.id
            );
            return (
              <span>
                {rs
                  ? dayjs(rs?.createdAt! * 1000).format("HH:mm, DD/MM/YYYY")
                  : "--"}
              </span>
            );
          }}
        />
      </Table>
      {/* <div style={{ marginTop: "3em" }}>
        <Pagination
          total={total}
          currentPage={query.page}
          onChange={({ limit, page }) => {
            query.page = page;
            query.limit = limit;
            setQuery({ ...query });
          }}
        />
      </div> */}
    </Modal>)
  );
};
